import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  greeting: [],
  allGreeting: []
};

export const GreetingsSlice = createSlice({
  name: "greetings",
  initialState,
  reducers: {
    getGreetingsAction: (state, action) => {
      state.allGreeting = action.payload;
    },
    getGreetingAction: (state, action) => {
      state.greeting = action.payload;
    },
  },
});

export default GreetingsSlice.reducer;

export const { getGreetingsAction, getGreetingAction } = GreetingsSlice.actions;
